<template>
    <transition 
        v-bind:enter-active-class="enterActiveClass"
        v-bind:leave-active-class="leaveActiveClass">
        <div v-if="active" class="ui vue page dimmer" v-bind:class="dimmerClass" v-on:click.self="cancel()">
            <div class="ui modal" v-bind:class="[modalClass, variant]">
                <slot v-bind:model="model" v-bind:actions="{cancel, close}"></slot>
            </div>
        </div>
    </transition>
</template>

<script>
import Bus from '../Bus.js'

export default {
    install(Vue) {
        Vue.prototype.$modal = (id, model) => {
            const promises = []

            Bus.$emit('show-modal', {
                id, 
                model, 
                waitUntil: (promise) => promises.push(promise)
            })

            return Promise.all(promises)
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        enterTransition: {
            type: String,
            default: 'fade in'
        },
        leaveTransition: {
            type: String,
            default: 'fade out'
        },
        variant: {
            type: String,
            default: 'tiny'
        }
    },
    data() {
        return {
            active: false,
            model: null
        }
    },
    created() {
        Bus.$on('show-modal', (modal) => {
            if (this.id !== modal.id || this.active) {
                return
            }

            this.model = modal.model
            this.active = true

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    this.cancel()
                }
            }, {once: true})

            document.body.classList.add('dimmable', 'dimmed')

            modal.waitUntil(new Promise((resolve, reject) => {
                this.$_resolve = resolve
                this.$_reject = reject
            }))
        })
    },
    computed: {
        dimmerClass() {
            return {
                active: this.active
            }
        },
        modalClass() {
            return {
                active: this.active
            }
        },
        enterActiveClass() {
            return `transition ${this.enterTransition}`
        },
        leaveActiveClass() {
            return `transition ${this.leaveTransition}`
        }
    },
    methods: {
        cancel() {
            if (!this.active) {
                return
            }

            document.body.classList.remove('dimmable', 'dimmed')

            this.active = false
            this.$_reject()
        },
        close(result) {
            if (!this.active) {
                return
            }

            document.body.classList.remove('dimmable', 'dimmed')

            this.active = false
            this.$_resolve(result)
        }
    }
}
</script>